import axios from "axios";
import {getApiToken, getSubscriptionPutToken} from "./firebase.mjs";
import {logger} from "./logger.mjs";

const base = 'https://cms.gsmgroup.africa/api/';

export const httpGetRequest = async (path) => {
    try {
        const apiToken = await getApiToken();
        const _path = `${path}`.trim().startsWith('/') ? `${path}`.replace('/', '') : path;
        const response = await axios.get(`${base}${_path}`, {
            headers: {
                'Authorization': `Bearer ${apiToken}`
            }
        });
        return response.data;
    } catch (e) {
        logger.warn(e);
        return null;
    }
}

export async function emailSubscriptionHttpRequest(email) {
    // try {
        const subscriptionPutToken = await getSubscriptionPutToken();
        // const _path = `${path}`.trim().startsWith('/')?`${path}`.replace('/',''):path;
        const response = await axios.post(`${base}subcriptions`, {
            data: {
                email
            }
        }, {
            headers: {
                'Authorization': `Bearer ${subscriptionPutToken}`
            }
        });
        return response.data;
    // } catch (e) {
    //     console.log(e);
    //     return null;
    // }
}
